import AuthService from "@/auth/auth.service";

export const authService = new AuthService(false);
export const authServicePowerBi = new AuthService(true);
